import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import './App.css';
import VideoList from './Pages/VideoList';

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/hololive/">
        <Routes>
          <Route path={`/`} element={<VideoList />} />
          <Route path={`/index.html`} element={<VideoList />} />
        </Routes>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
